import { useEffect, useRef } from 'react';
import { occasions } from '@/mocks/homeData';

export default function OccasionsSection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.querySelectorAll('.occ-animate').forEach((child, i) => {
              (child as HTMLElement).style.animationDelay = `${i * 0.1}s`;
              child.classList.add('animate-fade-in-up');
            });
            obs.unobserve(el);
          }
        });
      },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} className="relative w-full py-24 md:py-32 bg-background-950">
      {/* Yellow accent line top */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary-500/30 to-transparent" />

      <div className="w-full px-6 md:px-10 lg:px-16">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
          <div>
            <p className="occ-animate opacity-0 text-primary-500 text-xs font-bold tracking-[0.3em] uppercase mb-4">
              Occasions
            </p>
            <h2 className="occ-animate opacity-0 text-3xl sm:text-4xl md:text-5xl font-black text-foreground-50 tracking-tight leading-tight">
              Every reason to<br />
              <span className="text-primary-500">send a drink.</span>
            </h2>
          </div>
          <p className="occ-animate opacity-0 text-foreground-500 text-sm max-w-sm">
            Birthdays, dates, friends, celebrations, or just because. MARKER fits every moment worth sharing.
          </p>
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {occasions.map((o) => (
            <div
              key={o.id}
              className="occ-animate opacity-0 group relative overflow-hidden rounded-2xl aspect-[4/5] cursor-pointer"
            >
              <img
                src={o.image}
                alt={o.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/40 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <p className="text-primary-500 text-xs font-bold tracking-[0.2em] uppercase mb-1">{o.title}</p>
                <p className="text-foreground-50 text-lg font-bold">{o.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}